import React, {useCallback, useMemo} from "react";
import {Col, Row} from "react-bootstrap";
import DonutsCard from "./sub-components/donutCards";
import {useNavigate} from "react-router-dom";
import {ToPhotographySkeleton} from "../photography/sub-components/skeleton";

const ToPhotography = ({
                           currentPage,
                           startDate,
                           endDate,
                           setCurrentPage,
                           allPhotographyList,
                           isPhotographyLoading,
                       }) => {
    const navigate = useNavigate();
    const handlePageChange = useCallback(() => {
        setCurrentPage(prev => prev + 1);
    }, [setCurrentPage]);

    const handleNavigate = useCallback((user) => {
        navigate("/photography/details-view", {state: {user, startDate, endDate}})
    }, [navigate, startDate, endDate]);

    const users = useMemo(() => allPhotographyList?.users || [], [allPhotographyList]);
    const totalCount = allPhotographyList?.totalCount ?? 0;

    if (isPhotographyLoading) {
        return (
            <>
                <p className="secondHeader">Photography</p>
                <Row>
                    <ToPhotographySkeleton/>
                </Row>
            </>
        );
    }

    if (!users.length) {
        return (
            <>
                <p className="secondHeader">Photography</p>
                <Row>
                    <img
                        alt="No data found"
                        src="no-data.gif"
                        style={{
                            width: "200px",
                            display: "block",
                            margin: "0 auto",
                            objectFit: "contain",
                        }}
                    />
                </Row>
            </>
        )
    }

    return (
        <>
            <p className="secondHeader">Photography</p>
            <Row>
                {users.map((user, i) => (
                    <Col
                        xl={4}
                        xxl={4}
                        lg={4}
                        md={6}
                        xs={12}
                        sm={12}
                        key={user.id || i}
                        onClick={() => {
                            handleNavigate(user)
                        }}
                        style={{cursor: "pointer"}}
                    >
                        <DonutsCard left="Daily Average" last="High Score" user={user}/>
                    </Col>
                ))
                }
                {users.length < totalCount && (
                    <p
                        className="secondHeader"
                        style={{cursor: "pointer"}}
                        onClick={handlePageChange}
                    >Load More</p>
                )}
            </Row>
        </>
    );
};

export default ToPhotography;
